import {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { useLoginMutation } from "../../../api/LoginAPI";
import useSignInStore from "../../../store/SignInStore";
import { toast } from "../../../utils/toast";

const SignInPage = () => {
    const navigate = useNavigate();
    const {
        loginId,
        password,
        isLoading,
        error,
        setId,
        setPassword,
        setLoading,
        setError,
        resetForm,
        setLoggedIn,
    } = useSignInStore();
    const loginMutation = useLoginMutation();
    const [rememberMe, setRememberMe] = useState(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const oauth2Error = urlParams.get("oauth2error");
        const provider = urlParams.get("provider"); // 👈 signupType 같이 받기

        if (oauth2Error) {
            // 저장 후 URL 정리
            localStorage.setItem("oauth2Error", oauth2Error);
            if (provider) {
                localStorage.setItem("oauth2Provider", provider);
            }
            window.history.replaceState({}, document.title, "/login");
        }

        const savedError = localStorage.getItem("oauth2Error");
        const savedProvider = localStorage.getItem("oauth2Provider");

        if (savedError === "alreadyexist" && savedProvider) {
            toast(decodeURIComponent(provider));
            localStorage.removeItem("oauth2Error");
            localStorage.removeItem("oauth2Provider");
            window.history.replaceState({}, document.title, "/login");
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const result = await loginMutation.mutateAsync({
                loginId,
                password,
            });
            if (rememberMe) {
                localStorage.setItem("authToken", result.token);
                localStorage.setItem("userId", result.userId);
            }
            setLoggedIn(true);
            resetForm();
            navigate("/");
        } catch (error) {
            console.error("로그인 실패:", error);

            setError(
                // error.message || "로그인에 실패했습니다. 다시 시도해 주세요."
                "로그인에 실패했습니다. 다시 시도해 주세요."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="sch-awrap">
            <div className="sch-no">SIGN IN</div>
            <h1>로그인</h1>

            <form onSubmit={handleSubmit} className="sch-aform">
                <label className="sc-field">
                    <span className="sc-field__label">아이디</span>
                    <input
                        type="text"
                        id="loginId"
                        className="sc-input"
                        value={loginId}
                        onChange={(e) => setId(e.target.value)}
                        placeholder="아이디를 입력해 주세요"
                        required
                    />
                </label>

                <label className="sc-field">
                    <span className="sc-field__label">비밀번호</span>
                    <input
                        type="password"
                        id="password"
                        className="sc-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="비밀번호를 입력해 주세요"
                        required
                    />
                </label>

                <div className="sch-arow">
                    <label className="sc-choice" style={{ fontSize: "13.5px" }}>
                        <input
                            id="remember"
                            name="remember"
                            type="checkbox"
                            className="sc-check"
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                        />
                        로그인 유지
                    </label>
                </div>

                {error && <div className="sc-alert sc-alert--danger">{error}</div>}

                <button
                    type="submit"
                    className="sch-bigbtn"
                    style={{ justifyContent: "center" }}
                    disabled={isLoading || !loginId || !password}
                >
                    {isLoading ? "로그인 중..." : "로그인"}
                </button>

                <div className="sch-alinks">
                    <button type="button" className="sch-alink" onClick={() => navigate("/find-id")}>아이디 찾기</button>
                    <span>·</span>
                    <button type="button" className="sch-alink" onClick={() => navigate("/find-pw")}>비밀번호 찾기</button>
                    <span>·</span>
                    <button type="button" className="sch-alink" onClick={() => navigate("/signup")}>회원가입</button>
                </div>

                <div className="sch-adiv">SNS 간편 로그인</div>

                <div className="sch-sns">
                    <button
                        type="button"
                        aria-label="네이버로 로그인"
                        onClick={() => {
                            window.location.href = "http://localhost:8080/oauth2/authorization/naver";
                        }}
                    >
                        <img src="/images/naver_icon.png" alt="Naver" />
                    </button>
                    <button
                        type="button"
                        aria-label="카카오로 로그인"
                        onClick={() => {
                            window.location.href = "http://localhost:8080/oauth2/authorization/kakao";
                        }}
                    >
                        <img src="/images/kakako_icon.png" alt="Kakao" />
                    </button>
                    <button
                        type="button"
                        aria-label="구글로 로그인"
                        onClick={() => {
                            toast("구글 로그인은 현재 준비중입니다. 불편을 드려서 죄송합니다.");
                        }}
                    >
                        <img src="/images/google_icon.png" alt="Google" />
                    </button>
                </div>
            </form>
        </div>
    );
};

export default SignInPage;
